(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aadil-extra-offer-rows"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aadil-offer-rail')) {
  customElements.define('aadil-offer-rail', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), {once: true, signal: this.abort.signal});
      } else {
        this.init();
      }
    }
    init() {
      this.track = this.querySelector('.aex-track');
      this.controls = this.querySelector('[data-aex-controls]');
      if (!this.track || !this.controls) return;
      this.previous = this.querySelector('[data-aex-direction="-1"]');
      this.next = this.querySelector('[data-aex-direction="1"]');
      this.position = this.querySelector('[data-aex-position]');
      this.cards = [...this.track.querySelectorAll('.aex-card')];
      this.onScroll = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.track.addEventListener('scroll', this.onScroll, {passive: true, signal: this.abort.signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-aex-direction]');
        if (!button || button.disabled) return;
        this.track.scrollBy({left: Number(button.dataset.aexDirection) * this.step * this.visible, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, {signal: this.abort.signal});
      if ('ResizeObserver' in window) {
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
      } else {
        window.addEventListener('resize', this.onScroll, {passive: true, signal: this.abort.signal});
      }
      this.update();
    }
    update() {
      if (!this.cards.length) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.step = this.cards[0].getBoundingClientRect().width + gap;
      if (this.step <= 0) return;
      this.visible = Math.max(1, Math.floor((this.track.clientWidth + gap) / this.step));
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = max <= 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= max - 2;
      const first = Math.min(this.cards.length, Math.round(this.track.scrollLeft / this.step) + 1);
      this.position.textContent = `${first}–${Math.min(this.cards.length, first + this.visible - 1)} / ${this.cards.length}`;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.resize?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadil-mega-offer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aadil-offer-carousel'))customElements.define('aadil-offer-carousel',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;const track=this.querySelector('.am2-track');if(!track){this.frame=requestAnimationFrame(()=>this.connectedCallback());return}this.ready=true;const slides=[...this.querySelectorAll('[data-slide]')],dots=[...this.querySelectorAll('[data-dot]')],pause=this.querySelector('[data-pause]');const reduced=matchMedia('(prefers-reduced-motion: reduce)');let index=0,paused=this.dataset.autoplay!=='true'||reduced.matches,hover=false;const sync=()=>{dots.forEach((b,i)=>i===index?b.setAttribute('aria-current','true'):b.removeAttribute('aria-current'));pause.setAttribute('aria-pressed',String(paused));pause.setAttribute('aria-label',paused?this.dataset.playLabel:this.dataset.pauseLabel);pause.textContent=paused?'▷':'Ⅱ'};const go=i=>{index=(i+slides.length)%slides.length;track.scrollTo({left:slides[index].offsetLeft-slides[0].offsetLeft,behavior:reduced.matches?'instant':'smooth'});sync()};const stop=()=>{paused=true;sync()};this.querySelector('[data-prev]').onclick=()=>{stop();go(index-1)};this.querySelector('[data-next]').onclick=()=>{stop();go(index+1)};dots.forEach((b,i)=>b.onclick=()=>{stop();go(i)});pause.onclick=()=>{paused=!paused;sync()};track.addEventListener('pointerdown',stop,{passive:true});track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();stop();go(index+(e.key==='ArrowRight'?1:-1))}});track.addEventListener('scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>{index=Math.round(track.scrollLeft/track.clientWidth);sync()})},{passive:true});this.addEventListener('mouseenter',()=>hover=true);this.addEventListener('mouseleave',()=>hover=false);this.timer=setInterval(()=>{if(!paused&&!hover&&!this.contains(document.activeElement)&&!document.hidden&&!document.querySelector('dialog[open]')&&!document.querySelector('cart-drawer.active'))go(index+1)},6000);this.motionChange=()=>{if(reduced.matches)stop()};reduced.addEventListener('change',this.motionChange);this.motionQuery=reduced;sync()}
 disconnectedCallback(){clearInterval(this.timer);cancelAnimationFrame(this.frame);cancelAnimationFrame(this.scrollFrame);this.motionQuery?.removeEventListener('change',this.motionChange);this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadil-sale-sizes"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aadil-sale-sizes'))customElements.define('aadil-sale-sizes',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  if(!this.querySelector('[data-size]')){this.frame=requestAnimationFrame(()=>this.connectedCallback());return}
  this.ready=true;this.size='all';this.price='all';this.initialLimit=Number(this.dataset.initial)||24;this.limit=this.initialLimit;
  this.sizeJump=event=>{const link=event.target.closest('a[href="#mega-sale-sizes"]');if(!link)return;const drawer=document.getElementById('Details-menu-drawer-container');if(drawer?.open)drawer.querySelector('summary')?.click()};document.addEventListener('click',this.sizeJump);
  this.cards=[...this.querySelectorAll('[data-sale-card]')].map(card=>({card,variants:JSON.parse(card.dataset.variants)}));
  this.sizes=[...this.querySelectorAll('[data-size]')];this.prices=[...this.querySelectorAll('[data-price]')];
  this.sizes.forEach(button=>button.addEventListener('click',()=>{this.size=button.dataset.size;this.limit=this.initialLimit;this.update()}));
  this.prices.forEach(button=>button.addEventListener('click',()=>{this.price=button.dataset.price;this.limit=this.initialLimit;this.update()}));
  this.querySelector('[data-reset]').addEventListener('click',()=>{this.size='all';this.price='all';this.limit=this.initialLimit;this.update();this.sizes[0].focus()});
  this.querySelector('[data-more]').addEventListener('click',()=>{const previous=this.limit;this.limit+=12;this.update();this.filteredCards[previous]?.card.querySelector('a')?.focus()});
  this.update();
 }
 eligible(variants,size=this.size){return variants.filter(v=>(size==='all'||v.size===size)&&(this.price==='all'||String(v.price)===this.price)).sort((a,b)=>a.price-b.price)}
 update(){
  this.sizes.forEach(button=>{const size=button.dataset.size;button.setAttribute('aria-pressed',String(size===this.size));const count=this.cards.filter(item=>this.eligible(item.variants,size).length).length;button.querySelector('[data-size-count]').textContent=this.dataset.countLabel.replace('__COUNT__',String(count))});
  this.prices.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.price===this.price)));
  this.filteredCards=[];
  this.cards.forEach(item=>{
   const variant=this.eligible(item.variants)[0];item.card.hidden=!variant||this.filteredCards.length>=this.limit;
   if(!variant)return;this.filteredCards.push(item);
   item.card.querySelectorAll('[data-product-link]').forEach(link=>link.href=variant.url);
   item.card.querySelector('[data-money]').textContent=variant.money;
   const compare=item.card.querySelector('[data-compare]'),saving=item.card.querySelector('[data-saving]');compare.hidden=!(variant.compare>variant.price);saving.hidden=compare.hidden;compare.textContent=variant.compareMoney;saving.textContent=variant.saving;
   const label=variant.size?this.dataset.sizeLabel.replace('__SIZE__',variant.size):this.dataset.allLabel;
   item.card.querySelector('[data-card-size]').textContent=label+' · '+this.querySelector('[data-stock-text]').textContent;
   item.card.querySelector('[data-shop-label]').textContent=variant.size?this.dataset.chooseLabel.replace('__SIZE__',variant.size):this.dataset.allLabel;
  });
  this.querySelector('[data-results]').textContent=this.dataset.countLabel.replace('__COUNT__',String(this.filteredCards.length))+' · '+(this.size==='all'?this.dataset.allLabel:this.dataset.sizeLabel.replace('__SIZE__',this.size));
  this.querySelector('[data-empty]').hidden=this.filteredCards.length>0;this.querySelector('[data-more]').hidden=this.filteredCards.length<=this.limit;
 }
 disconnectedCallback(){cancelAnimationFrame(this.frame);document.removeEventListener('click',this.sizeJump);this.ready=false}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadil-v5-collections"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aadil-product-row'))customElements.define('aadil-product-row',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.av5-product-track'),controls=this.querySelector('.av5-row-controls'),buttons=[...controls.querySelectorAll('button')];this.sync=()=>{controls.hidden=track.scrollWidth<=track.clientWidth+2;buttons[0].disabled=track.scrollLeft<2;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.direction)*track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));track.addEventListener('scroll',this.sync,{passive:true});this.observer=new ResizeObserver(this.sync);this.observer.observe(track);this.sync()}disconnectedCallback(){this.observer?.disconnect();this.ready=false}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadil-v5-giveaway"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aadil-entry-form')) customElements.define('aadil-entry-form', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.dialog = this.querySelector('.am2-dialog');
    if (!this.dialog) { this.frame = requestAnimationFrame(() => this.connectedCallback()); return; }
    this.ready = true;
    this.abort = new AbortController();
    const on = (element, event, handler) => element?.addEventListener(event, handler, {signal: this.abort.signal});
    this.launcher = this.querySelector('[data-entry-open]');
    const form = this.querySelector('form');
    this.openEntry = element => {
      this.launcher.hidden = false;
      this.trigger = element;
      if (this.invite?.open) { this.handoff = true; this.invite.close(); }
      try { if (!this.dialog.open) this.dialog.showModal(); } catch { return false; }
      this.rememberInvite();
      document.documentElement.classList.add('am2-entry-open');
      return true;
    };
    const shut = () => this.dialog.close();
    this.initInvite(on);
    this.launcher.hidden = !this.inviteSeen();
    this.timer = setTimeout(() => { this.launcher.hidden = false; this.maybeInvite(); }, Number(this.dataset.delay) || 7000);
    on(this.launcher, 'click', () => this.openEntry(this.launcher));
    on(this.querySelector('[data-entry-close]'), 'click', shut);
    on(document, 'click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const button = event.target.closest('[data-aadil-giveaway-open],a[href$="#aadil-campaign-giveaway"]');
      if (!button) return;
      if (this.openEntry(button)) event.preventDefault();
    });
    on(this.dialog, 'close', () => {
      document.documentElement.classList.remove('am2-entry-open');
      this.restoreFocus(this.trigger);
    });
    on(this.dialog, 'click', event => { if (this.outside(this.dialog, event)) shut(); });
    const name = form.elements.namedItem('contact[name]'), phone = form.elements.namedItem('contact[phone]');
    if (name && phone) {
      on(name, 'input', () => name.setCustomValidity(''));
      on(phone, 'input', () => phone.setCustomValidity(''));
      on(form, 'submit', event => {
        name.setCustomValidity(name.value.trim().length >= 2 ? '' : this.dataset.nameError);
        const digits = phone.value.replace(/\D/g, '');
        const national = digits.length === 12 && digits.startsWith('91') ? digits.slice(2) : digits.length === 11 && digits.startsWith('0') ? digits.slice(1) : digits;
        phone.setCustomValidity(/^[6-9]\d{9}$/.test(national) ? '' : this.dataset.phoneError);
        if (!form.reportValidity()) { event.preventDefault(); return; }
        phone.value = '+91' + national;
      });
    }
    const success = this.querySelector('[data-entry-success]');
    if (success) {
      const confirm = this.querySelector('[data-follow-confirm]'), continueButton = this.querySelector('[data-follow-continue]'), after = this.querySelector('[data-after-follow]');
      after.hidden = true;
      on(confirm, 'change', () => {
        continueButton.disabled = !confirm.checked;
        if (!confirm.checked) { after.hidden = true; continueButton.hidden = false; continueButton.setAttribute('aria-expanded', 'false'); this.updateProgress(false); }
      });
      on(continueButton, 'click', () => {
        if (!confirm.checked) return;
        after.hidden = false; continueButton.hidden = true; continueButton.setAttribute('aria-expanded', 'true'); this.updateProgress(true); this.querySelector('[data-app-request]').focus();
      });
      on(this.querySelector('[data-entry-done]'), 'click', shut);
      let seen = false;
      try { seen = sessionStorage.getItem('aadil-entry-thanks-seen') === '1'; } catch {}
      if (!seen && !matchMedia('(prefers-reduced-motion:reduce)').matches) {
        const stage = this.querySelector('.am3-celebration');
        for (let i = 0; i < 12; i++) {
          const particle = document.createElement('i');
          particle.textContent = ['✦','●','✧'][i % 3];
          particle.style.setProperty('--i', i);
          stage.appendChild(particle);
          particle.addEventListener('animationend', () => particle.remove(), {once: true});
        }
        try { sessionStorage.setItem('aadil-entry-thanks-seen', '1'); } catch {}
      }
    }
    const returned = this.querySelector('[data-entry-return]');
    if (returned && this.openEntry(this.launcher)) { returned.setAttribute('tabindex', '-1'); returned.focus(); }
  }
  inviteSeen() {
    if (this.seenHere) return true;
    try { return sessionStorage.getItem('aadil-giveaway-invite-202610-v1') === '1'; } catch { return true; }
  }
  rememberInvite() {
    this.seenHere = true;
    clearTimeout(this.timer); clearTimeout(this.inviteTimer);
    try { sessionStorage.setItem('aadil-giveaway-invite-202610-v1', '1'); } catch {}
  }
  initInvite(on) {
    this.invite = this.querySelector('.am7-invite');
    if (!this.invite) return;
    on(this.invite, 'close', () => {
      document.documentElement.classList.remove('am7-invite-open');
      if (!this.handoff) this.restoreFocus(this.invitePrevious);
    });
    this.invite.querySelectorAll('[data-invite-close]').forEach(button => on(button, 'click', () => this.invite.close()));
    on(this.invite, 'click', event => { if (this.outside(this.invite, event)) this.invite.close(); });
    on(this.invite.querySelector('[data-invite-enter]'), 'click', () => {
      this.rememberInvite(); this.handoff = true; this.invite.close();
      this.frame = requestAnimationFrame(() => this.openEntry(this.launcher));
    });
  }
  maybeInvite() {
    if (this.dataset.autoInvite !== 'true' || !this.invite || this.inviteSeen() || this.querySelector('[data-entry-return]')) return;
    const typing = document.activeElement?.matches('input,textarea,select,[contenteditable="true"]');
    const busy = document.querySelector('dialog[open],#Details-menu-drawer-container[open],cart-drawer.active,details[open] .search-modal');
    if (document.visibilityState !== 'visible' || typing || busy) {
      this.inviteAttempts = (this.inviteAttempts || 0) + 1;
      this.inviteTimer = setTimeout(() => this.maybeInvite(), this.inviteAttempts < 30 ? 1000 : 5000);
      return;
    }
    this.invitePrevious = document.activeElement;
    this.handoff = false;
    try { this.invite.showModal(); } catch { return; }
    this.rememberInvite();
    document.documentElement.classList.add('am7-invite-open');
  }
  outside(dialog, event) {
    if (event.target !== dialog) return false;
    const rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
  }
  restoreFocus(element) {
    const visible = target => target?.isConnected && target.matches('a[href],button,input,select,textarea,[tabindex]') && !target.matches(':disabled,[inert]') && target.getClientRects().length && getComputedStyle(target).visibility !== 'hidden';
    const fallback = [this.launcher, ...document.querySelectorAll('[data-aadil-giveaway-open]')].find(visible);
    const canRestore = visible(element);
    if (canRestore) element.focus({preventScroll: true});
    if (!canRestore || document.activeElement !== element) fallback?.focus({preventScroll: true});
  }
  updateProgress(done) {
    const follow = this.querySelector('[data-progress-follow]'), app = this.querySelector('[data-progress-app]');
    follow.classList.toggle('is-complete', done);
    if (done) { follow.removeAttribute('aria-current'); app.setAttribute('aria-current', 'step'); }
    else { follow.setAttribute('aria-current', 'step'); app.removeAttribute('aria-current'); }
  }
  disconnectedCallback() {
    clearTimeout(this.timer); clearTimeout(this.inviteTimer); cancelAnimationFrame(this.frame);
    this.abort?.abort();
    if (this.invite?.open) this.invite.close();
    if (this.dialog?.open) this.dialog.close();
    document.documentElement.classList.remove('am2-entry-open', 'am7-invite-open');
    this.ready = false;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aadil-v5-reels"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('aadil-reel-strip'))customElements.define('aadil-reel-strip',class extends HTMLElement{connectedCallback(){if(this.ready)return;const track=this.querySelector('.av5-reel-grid');if(!track){this.frame=requestAnimationFrame(()=>this.connectedCallback());return}this.ready=true;const prev=this.querySelector('[data-reel-prev]'),next=this.querySelector('[data-reel-next]');const sync=()=>{prev.disabled=track.scrollLeft<2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2};const move=dir=>track.scrollBy({left:dir*(track.querySelector('.av5-reel').getBoundingClientRect().width+18),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});prev.onclick=()=>move(-1);next.onclick=()=>move(1);track.addEventListener('scroll',sync,{passive:true});track.addEventListener('keydown',e=>{if(e.target===track&&(e.key==='ArrowRight'||e.key==='ArrowLeft')){e.preventDefault();move(e.key==='ArrowRight'?1:-1)}});this.resize=new ResizeObserver(sync);this.resize.observe(track);sync()}disconnectedCallback(){cancelAnimationFrame(this.frame);this.resize?.disconnect();this.ready=false}});
if(!customElements.get('aadil-instagram-reel'))customElements.define('aadil-instagram-reel',class extends HTMLElement{connectedCallback(){if(this.ready)return;const button=this.querySelector('button');if(!button){this.frame=requestAnimationFrame(()=>this.connectedCallback());return}this.ready=true;button.addEventListener('click',()=>{let url;try{url=new URL(this.dataset.url)}catch{return}const match=url.pathname.match(/^\/(?:reel|p)\/([A-Za-z0-9_-]+)\/?$/);if(!['www.instagram.com','instagram.com'].includes(url.hostname)||!match)return;const frame=document.createElement('iframe');frame.src='https://www.instagram.com/reel/'+match[1]+'/embed/';frame.title=this.dataset.title||'Instagram';frame.allow='encrypted-media; fullscreen; picture-in-picture';frame.referrerPolicy='strict-origin-when-cross-origin';frame.loading='lazy';this.replaceChildren(frame)})}disconnectedCallback(){cancelAnimationFrame(this.frame)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
